import Service from 'app/services/Service'

class ShippingComplianceService extends Service {
  constructor() {
    super('/shipping/service/v1/compliances')
  }
  async getShippingComplianceAndTax(draftOrderId: any) {
    const response = await this.get(`/draft/${draftOrderId}`)
    return response
  }
  async getShippingComplianceAndTaxByOrder(params: any) {
    const response = await this.post(params, `/orders`)
    return response
  }

  async checkOrderEditCompliance(order: {orderId: string; orderEditId: string}) {
    try {
      const response = await this.post(order, `/order/edit`)
      return response
    } catch (err) {
      console.log(err)
    }
  }
}

const shippingComplianceService = new ShippingComplianceService()
export default shippingComplianceService
